<template>
        <div class="TQ_center">

            <!-- approve tickets-->
            <tq-card padding="16px" margin="16px" min-width="1000px">
                <div class="TQ_text_28px">
                    Requested Tickets
                </div>
                <hr>

                <div class="TQ_padding_8px TQ_bg_gray1">
                    <tq-table
                            class="TQ_padding_8px TQ_bg_white"
                            :rows="questsTickets_ac"
                            :system-lang-code="store_system_langCode_ve.val"
                            :display-search="true"
                            p_td-classes_s="TQ_padding_8px"
                            :columns="[
                            {label : 'Ticket Id',       field (questTicket_c){return questTicket_c.qt_ticketId_uid}},
                            {label : 'Event Date',      field (questTicket_c){return questEvent_byTicketId_c[questTicket_c.qt_ticketId_uid]    ? format_date_YYYY_MM_DD_hh_mm_fs(questEvent_byTicketId_c[questTicket_c.qt_ticketId_uid].qev_startingDate_t) : 'Loading...'}},
                            {label : 'Event Name',      field (questTicket_c){return questEvent_byTicketId_c[questTicket_c.qt_ticketId_uid]    ? questEvent_byTicketId_c[questTicket_c.qt_ticketId_uid].qev_supportedLangCodes_ae.map((lanCode_e) => {return lanCode_e + '-' +  questEvent_byTicketId_c[questTicket_c.qt_ticketId_uid].qev_name_byLangCode_s[lanCode_e]}) : 'Loading...'}},
                            {label : 'Spots',           field (questTicket_c){return questTicket_c.qt_spots_n }},
                            {label : 'Cost',            field (questTicket_c){return format_cost_s(questTicket_c.qt_cost_c)}},
                            {label : 'Creator Text',    field (questTicket_c){return questTicket_c.qt_creatorText_s}},
                            {label : 'Status',          field (questTicket_c){return questTicket_c.qt_status_e}},
                        ]"
                            :p_actions_ao="[
                            {
                                label_byLangCode : ass_strings.oneWord_approved,
                                popupText_byLangCode : ass_strings.question_approveTicket,
                                action_f : m_clickApproveTicket_f,
                                class : 'TQ_bg_green',
                                display :(questTicket_c) => {return [enum_questTicketStatus.creatorRequest].includes(questTicket_c.qt_status_e)}
                            },
                            {
                                label_byLangCode : ass_strings.oneWord_decline,
                                popupText_byLangCode : ass_strings.question_cancelTicketMsg,
                                action_f : m_clickDeclineTicket_f,
                                class : 'TQ_bg_red' ,
                                display :(questTicket_c) => {return [enum_questTicketStatus.creatorRequest, enum_questTicketStatus.creatorRequestApproved].includes(questTicket_c.qt_status_e)}
                            },
                            {
                                label_byLangCode : ass_strings.oneWord_charge,
                                popupText_byLangCode : ass_strings.question_cancelTicketMsg,
                                action_f : m_clickChargeTicket_f,
                                class : 'TQ_bg_purple' ,
                                display :(questTicket_c) => {return [enum_questTicketStatus.approved].includes(questTicket_c.qt_status_e)}
                            },
                        ]"
                    />
                </div>
                <hr>

                <tq-loader-button text="Get All tickets requests"
                                  btn-class="TQ_btn TQ_bg_green"
                                  @clickBtn="m_getRequestedTickets_f"
                                  :show-loader="showBtnLoader_b"/>

                <div class="TQ_padding_8px TQ_inline "></div>
                <tq-loader-button text="Get last month tickets"
                                  btn-class="TQ_btn TQ_bg_gold"
                                  @clickBtn="m_getLastMonthTicket_f"
                                  :show-loader="showBtnLoader_b"/>

            </tq-card>




        </div>
</template>

<script>
    import TqLoaderButton from "../../components/basic2/TqLoaderButton";
    import TqTable from "../../components/basic2/TqTable";
    import {format_cost_s} from "../../../functions/src/shareCode/Share_S_Format";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {format_date_YYYY_MM_DD_hh_mm_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import {obj_forEach_f, obj_toArray_fo} from "../../../functions/src/shareCode/Share_S_Obj";
    import TqCard from "../../components/basic/TqCard";
    import {store_getStateValue_vo, store_var} from "../../store";
    import {
        serverPre_updateTicket_f,
        server_questEvent_once_f, server_questsTicket_all_f,
        server_requestedTickets_once_f, server_tickets_startDate_once_f, serverPre_chargeTicket_f
    } from "../../scripts/Server/S_ServerPre";
    import {enum_questTicketStatus, enum_questTicketActions} from "../../../functions/src/shareCode/Share_S_Enum";
    import {date_newDate_fd} from "../../scripts/S_Date";
    import {FB_QuestTicket_History} from "../../../functions/src/shareCode/Share_S_Classes";
    export default {
        name: "v_Admin_Manage_Tickets",
        components: {TqCard, TqTable, TqLoaderButton},

        data(){
            return {
                tickets_ac: [],
                showBtnLoader_b: false,
                questsTickets_ac: [],
                questEvent_byTicketId_c: {},
                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),

                enum_questTicketStatus : enum_questTicketStatus,
                ass_strings : ass_strings,
                format_cost_s : format_cost_s,
                format_date_YYYY_MM_DD_hh_mm_fs : format_date_YYYY_MM_DD_hh_mm_fs,
                format_dateFull : format_date_YYYY_MM_DD_hh_mm_fs,

            }
        },
        methods:{
            m_clickApproveTicket_f(questTicket_c , index){

                questTicket_c.qt_status_e = enum_questTicketStatus.approved;
                questTicket_c.qt_history_ac.push(new FB_QuestTicket_History({
                    qth_timestamp_t     : date_newDate_fd().getTime(),
                    qth_actions_e       : enum_questTicketActions.approve,
                }))


                serverPre_updateTicket_f(this.questEvent_byTicketId_c[questTicket_c.qt_ticketId_uid]).then(() => {})
            },
            m_clickDeclineTicket_f(questTicket_c, index){

                this.questsTickets_ac.splice(index,1)

                questTicket_c.qt_status_e = enum_questTicketStatus.canceled;
                questTicket_c.qt_history_ac.push(new FB_QuestTicket_History({
                    qth_timestamp_t     : date_newDate_fd().getTime(),
                    qth_actions_e       : enum_questTicketActions.cancel,
                }))

                serverPre_updateTicket_f(this.questEvent_byTicketId_c[questTicket_c.qt_ticketId_uid]).then( questTicket_c, () => {})

            },
            m_clickChargeTicket_f(questTicket_c){
                serverPre_chargeTicket_f({
                    ticketId_uid : questTicket_c.qt_ticketId_uid,
                })
            },
            m_getRequestedTickets_f(){

                this.questsTickets_ac = []
                this.showBtnLoader_b = true

                server_requestedTickets_once_f((questTickets_byTicketId_c) => {

                    this.questsTickets_ac = obj_toArray_fo(questTickets_byTicketId_c)
                    this.showBtnLoader_b = false

                    obj_forEach_f(questTickets_byTicketId_c, (questTicket_c) => {
                        server_questEvent_once_f(questTicket_c.qt_questType_e, questTicket_c.qt_questId_uid, questTicket_c.qt_eventId_uid, false, (questEvent_c) => {
                            this.$set(this.questEvent_byTicketId_c, questTicket_c.qt_ticketId_uid, questEvent_c)
                        })


                    })



                })
            },

            m_getLastMonthTicket_f(){

                this.questsTickets_ac = []
                this.showBtnLoader_b = true

                server_tickets_startDate_once_f(date_newDate_fd().setDate(-90), date_newDate_fd().setDate(-3),(questTickets_byTicketId_c) => {

                    this.questsTickets_ac = obj_toArray_fo(questTickets_byTicketId_c)
                    this.questsTickets_ac = this.questsTickets_ac.filter((questTicket_c) => {return questTicket_c.qt_status_e === enum_questTicketStatus.approved && questTicket_c.qt_cost_c.c_value_n > 0 && questTicket_c.qt_purchasedBy_e === 1})

                    this.showBtnLoader_b = false

                    obj_forEach_f(questTickets_byTicketId_c, (questTicket_c) => {
                        server_questEvent_once_f(questTicket_c.qt_questType_e, questTicket_c.qt_questId_uid, questTicket_c.qt_eventId_uid, false, (questEvent_c) => {

                            this.$set(this.questEvent_byTicketId_c, questTicket_c.qt_ticketId_uid, questEvent_c)

                        })

                    })
                })
            }
        },




    }
</script>

<style scoped>

</style>